import currency from 'currency.js';

export default function formatCents(cents: number | null | undefined) {
  if (!cents) return cents;
  return currency(cents, { fromCents: true }).format();
}
